import React, { useState, useEffect } from 'react';
import NavBar from '../Components/NavBar';
import "./ReceiptPage.css";
import CartProduct from '../Components/CartProduct';
import OrderDetails from '../Components/OrderDetails';
const Receipt = () => {

    const [cartItems, setCartItems] = useState([]);
    const [subtotal, setSubtotal] = useState(0);
    const [total, setTotal] = useState(0);

    useEffect(() => {
        const storedCart = JSON.parse(localStorage.getItem('cart')) || [];
        setCartItems(storedCart);
    }, []);

    useEffect(() => {
        // Retrieve cart items from local storage
        const cartItems = JSON.parse(localStorage.getItem('cart')) || [];

        // Calculate subtotal by summing up the prices of all products in the cart
        const subtotalAmount = cartItems.reduce((total, product) => {
            return total + parseFloat(product.price);
        }, 0);

        // Update the subtotal state
        setSubtotal(subtotalAmount);
        setTotal(subtotalAmount+5+2);
    }, []);

    return (
        <div>
            <NavBar></NavBar>
            <div class="order-summary-container">
                <div class="order-summary-text">
                    <h1>Order-Summary</h1>
                    <div class="order-date-info">
                        <div class="order-date-17">Order Date: April 17, 2024</div>
                        <div class="random-padding-receipt"></div>
                        <div class="order-num-1234">Order Number: 1234</div>
                    </div>
                </div>
                <div class="product-order-container">
                    <div >
                        {cartItems.map((product, index) => (
                                <CartProduct
                                    key={index}
                                    ProductName={product.product_name} // Use correct prop names
                                    Price={product.price}
                                    ImageUrl={"http:" + product.image_url} 
                                    showDeleteButton={false}
                                />
                            ))}
                    </div>
                    <div class="frame-221">
                        <div class="container-of-shipping">
                            <div class="shipping-container">
                                <h3>Shipping Address</h3>
                                <div class="frame-67">
                                    <div class="pickup-location-bold">
                                        Pickup Location:
                                    </div>
                                    <div class="pickup-loc-info">
                                        USC Village 929 W Jefferson Blvd #1620, Los Angeles, CA 90089
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="container-of-payment">
                            <div class="payment-container">
                                <div class="payment-title">
                                    Payment
                                </div>
                                <div class="payment-info">
                                    <div class="payment-method">
                                        Payment Method
                                    </div>
                                    <div class="visa">
                                        Visa -####
                                    </div>
                                    <div class="payment-method">
                                        Billing Details
                                    </div>
                                    <div class="tommy">
                                        Tommy Trojan
                                        123 McClintock Ave
                                        Los Angeles, CA 90007
                                        tommytrojan@usc.edu
                                        123-432-3456
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="container-of-summary-container">
                            <div class="summary-container">
                                <div class="summary-title">
                                    Summary
                                </div>
                                <div class="frame-206">
                                    <div class="frame-202">
                                        <div class="subtotal">
                                            Subtotal
                                        </div>
                                        <div class="the_total">
                                            ${subtotal.toFixed(2)}
                                        </div>
                                    </div>
                                    <div class="frame-202">
                                        <div class="subtotal">
                                            Shipping
                                        </div>
                                        <div class="crossed-out">
                                            $100.00
                                        </div>
                                    </div>
                                    <div class="frame-202">
                                        <div class="with-cart-pool">
                                            Shipping w/ Cartpool
                                        </div>
                                        <div class="the_total">
                                            $5.00
                                        </div>
                                    </div>
                                    <div class="frame-202">
                                        <div class="subtotal">
                                            Cartpool Fee
                                        </div>
                                        <div class="the_total">
                                            $2.00
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="order-total-receipt">
                            <div class="order-total-text">
                                Order total:
                            </div>
                            <div class="price-total-text">
                            ${total.toFixed(2)}
                            </div>
                        </div>

                    </div>
                </div>
            </div>



        </div >
    )
};
export default Receipt;